<div class="content center-content">
    <div class="column-flex">
        <div class="title-container">
            <div class="title">
                {{ 'mimic.settings.gauge.custom-divisions.title' | translate }}
            </div>
            <div class="subtitle">
                {{ 'mimic.settings.gauge.custom-divisions.subtitle' | translate }}
            </div>
        </div>

        <div class="section">
            <div class="title-wrapper">
                <div>{{ 'mimic.settings.gauge.custom-divisions.number' | translate }}</div>
                <div class="show-less-container" (click)="showDivisions = !showDivisions">
                    <div class="show-less-button">
                        {{ showDivisions ? ('dlg.show-less' | translate) : ('dlg.show-more' | translate) }}
                    </div>
                    <mat-icon svgIcon="arrow-down" class="arrow-down" [class.focus]="showDivisions" />
                </div>
            </div>
            <app-channel-select-input
                *ngIf="showDivisions"
                name="gaugeCustomDivisions"
                label="mimic.settings.gauge.custom-divisions.number"
                [value]="divisions"
                [itemList]="DivisionOptions"
                (inputChange)="handleDivisionsChange($event)"></app-channel-select-input>
        </div>

        <div class="section">
            <div class="title-wrapper">
                <div>{{ 'mimic.settings.gauge.custom-divisions.input' | translate }}</div>
                <div class="show-less-container" (click)="showScaleValues = !showScaleValues">
                    <div class="show-less-button">
                        {{ showScaleValues ? ('dlg.show-less' | translate) : ('dlg.show-more' | translate) }}
                    </div>
                    <mat-icon svgIcon="arrow-down" class="arrow-down" [class.focus]="showScaleValues" />
                </div>
            </div>
            <ng-container *ngIf="showScaleValues">
                <div class="description">
                    {{ 'mimic.settings.gauge.custom-divisions.description' | translate }}
                </div>
                <div class="scale-values-container">
                    <app-channel-text-input
                        *ngFor="let value of scaleValues; let i = index; trackBy: trackByIndex"
                        class="scale-value-input"
                        type="number"
                        [name]="'gaugeScaleValue' + i"
                        [value]="formatScaleValue(value)"
                        [noLabel]="true"
                        (onInputChange)="handleScaleValueChange(i, $event)"></app-channel-text-input>
                </div>
                <div *ngIf="!isValid" class="error-message">
                    {{ 'mimic.settings.gauge.custom-divisions.error' | translate: { min: data.min, max: data.max } }}
                </div>
            </ng-container>
        </div>

        <div class="buttons-container">
            <div class="button cancel" (click)="cancel()">
                {{ 'dlg.cancel' | translate }}
            </div>
            <div class="button select" [class.disabled-button]="!isValid" (click)="save()">
                {{ 'dlg.save' | translate }}
            </div>
        </div>
    </div>
</div>
